/**
 * SalonlarPage.jsx — Salonlar (SEÇİLİ FUARIN fuar alanına ait salonlar) (backlog #157, 2026-09-23)
 * Route: /Management/Salonlar
 *
 * "Salonlar ve Krokiler" menüsünde REZERVE duran girişi dolduruyor — bkz.
 * LayoutMenuData.js'in "'Salonlar' (fuar geneli salon listesi) alt girişi REZERVE" yorumu.
 *
 * Üstteki "Fuar Seç" ile seçilen fuarın fuar alanına kayıtlı HER salonu listeler ve her birini bu
 * fuara BAĞLAR/ÇIKARIR (salon_to_fuar satırı) — bağlanmadan bir salon Fuar Kuralları → Yükseklik
 * Limitleri sekmesinde hiç görünmez (o sekme yalnızca zaten bağlı salonları okur, GET
 * /{fuarId}/h-max). Bağlantı kurulduktan SONRA yükseklik ayarları hâlâ orada yönetilir — bu sayfa
 * yalnızca "bu salon bu fuarda var mı yok mu"yu yönetir, yükseklik değerlerini değil.
 *
 * Üç ayrı gerçek uçtan birleştiriliyor (tek bir birleşik uç yok, bkz. commit notu):
 *   1) listSalonlar(fuarAlaniId)  — fuar alanına kayıtlı TÜM salonlar (fuarAlaniSalonService)
 *   2) getFuarHMax(fuarId)        — bu fuara BAĞLI salonlar, salonToFuarId dahil (fuarKuralService)
 *   3) getSalonlarByFuar(fuarId)  — salon başına stand sayısı (krokiService, zaten var olan mantık)
 *
 * WAS: Kroki (floor-plan) sütunu KASITLI OLARAK "—" — salon başına toplu bir "kroki var mı"
 * kontrolü bilinmiyordu. Backlog #164 (2026-09-26): fdsvector'ün GET /api/fds/hall-floor-plan-map
 * ucu (krokiVectorService.getHallFloorPlanDocuments) fuar alanındaki her salonun Salon Planı
 * dokümanını verir — sütun artık oradan dolar: "Var" = dokümanı açılmış (çizilmiş olması şart
 * değil; çizim ilerlemesi #202'nin durumlarında, Salon Kartı'nda). Uç okunamazsa sütun "?" kalır,
 * sayfanın geri kalanı etkilenmez.
 *
 * Backlog #163 / #183 (2026-09-26): salon adı Salon Kartı'na (/Management/Salonlar/:salonId),
 * aktif bir salonun palet düğmesi Durum Haritası'na (/Management/Salonlar/:salonId/DurumHaritasi)
 * götürür.
 *
 * Backlog #204 (2026-09-26) — "Kroki" sütunu ikiye ayrıldı (#202'nin çizim durumlarıyla):
 *   Salon Planı          fuar alanındaki salonun Salon Planı durumu, BİLGİ AMAÇLI. Çizim yoksa
 *                        rozete tıklamak Salon Planı'nı tam düzenlemede açar (#193) — yalnızca o
 *                        rotaya girebilen gruplar için ([1,2,3]). #164'ün fdsvector doküman
 *                        kontrolü burada küçük bir ipucu olarak kaldı ("doküman var").
 *   Alan Planı (Kroki)   bu fuardaki salonun stand yerleşimi durumu. Rozet menüsü: "Alan Planına
 *                        Git" (SalonAlanPlaniPage, edit modu, Alan Planı katmanı — #205) ve
 *                        "Çizim Durumunu Değiştir". Salon bu fuarda aktif değilse "—".
 * "Stand Çizimi Tamamlandı" Salon Kartı'nda ve Alan Planı sayfasında (#163 artık var).
 *
 * 2026-09-27:
 *   #234 "Altyapı Planı" sütunu Salon Planı'nın yanında, yine BİLGİ AMAÇLI: durum burada
 *        değiştirilmez. Çizim yoksa rozet, Salon Planı'ndaki gibi, planı o katmanda açar
 *        (Bilge: #204'ün kısayolu kalsın).
 *   #228 Salon Planı sayfası artık katmanı adresten ister: rozetler ?katman=floorplan /
 *        ?katman=infrastructure ile açar.
 *   #236 Alan Planı, salonun Salon Planı TAMAMLANDI olmadan başlatılamaz (backend #235 de 409
 *        döner): menüde Çiziliyor / Tamamlandı ve "Alan Planına Git" kilitli, nedeni menüde ve
 *        rozetin altında. Çizim yok'a dönmek serbest.
 */
import React, { useCallback, useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Palette, Map as MapIcon } from "lucide-react";
import {
  Container, Card, CardBody, CardHeader, Table, Badge, Button, Spinner, Alert, DropdownItem,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import MainContext from "../../../Components/Contexts/MainContext";
import { getFuarHMax } from "../../../services/fuarKuralService";
import {
  listSalonlar, addSalonToFuar, removeSalonFromFuar, activateAllFairgroundSalons, setAlanPlaniDurumu,
} from "../../../services/fuarAlaniSalonService";
// #302: the link follows the role whose PAGES this login gets (pageAccess.js), like the route itself.
// WAS: import { getCurrentUserGroupId, isStaffAccount } from "../../../services/firmaSessionService";
import { isStaffAccount } from "../../../services/firmaSessionService";
// WAS (until #325): import { getCurrentPageAccessGroupId } from "../../../Routes/pageAccess";
import { useYetki, SAYFA_IZNI } from "../../../services/rbacService";
import {
  CIZIM_DURUM, CizimDurumuPill, alanPlaniEngeli, ALAN_PLANI_ENGEL_KISA, ALAN_PLANI_KILITLI_DURUMLAR,
} from "../../../Components/FairAreas/salonDurumlari";
import { CizilecekRozeti, YenidenCizilecekIsareti } from "../../../Components/FairAreas/cizilecek";

// WAS (until #325): SalonPlaniDuzenlePage'in rotası (allRoutes.js, /Management/FairAreas/...) bu gruplara açık.
// const SALON_PLANI_ROTA_GRUPLARI = [1, 2, 3];
// #325: o rota page.fuar.yonetim izniyle açılıyor; bağlantı da aynı izne bakar.
import { getSalonlarByFuar } from "../../../services/krokiService";
import { getHallFloorPlanDocuments, KROKI_LAYERS } from "../../../services/krokiVectorService";
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n";

export default function SalonlarPage() {
  const { t: tx } = useTranslation("yonetim");
  const { selectedFuarId } = useContext(MainContext);
  const navigate = useNavigate();
  const personel = isStaffAccount();
  // WAS (until #325): const salonPlaniAcabilir = SALON_PLANI_ROTA_GRUPLARI.includes(getCurrentPageAccessGroupId());
  const salonPlaniAcabilir = useYetki(SAYFA_IZNI.FUAR_YONETIM) === true;
  const [alanBusy, setAlanBusy] = useState(null); // salonId — o an Alan Planı durumu yazılan satır

  const [fuarAlaniId, setFuarAlaniId] = useState(null);
  const [fuarAlaniName, setFuarAlaniName] = useState(null);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);
  const [reloadToken, setReloadToken] = useState(0);

  useEffect(() => { document.title = i18n.t("yonetim:salonlar.salonlarFds"); }, []);
  const refresh = useCallback(() => setReloadToken((t) => t + 1), []);

  useEffect(() => {
    if (!successMsg) return undefined;
    const t = setTimeout(() => setSuccessMsg(null), 4500);
    return () => clearTimeout(t);
  }, [successMsg]);

  // KURAL: fetch mantığı Effect içindeki async fonksiyonda — bkz. FuarKurallariPage.jsx'teki aynı
  // desen (react-hooks/set-state-in-effect notu).
  useEffect(() => {
    if (!selectedFuarId) return undefined;
    let ignore = false;

    async function run() {
      setLoading(true);
      setError(null);
      try {
        const hmax = await getFuarHMax(selectedFuarId, { forceLive: true });
        if (ignore) return;
        const alaniId = hmax?.fuarAlaniId ?? null;
        setFuarAlaniId(alaniId);
        setFuarAlaniName(hmax?.fuarAlaniName ?? null);

        const linkedBySalonId = new Map(
          (hmax?.halls ?? []).map((h) => [Number(h.salonId), h])
        );

        // WAS: yalnızca listSalonlar + getSalonlarByFuar. #164: + fdsvector'ün salon planı eşlemesi
        // (kimlik doğrulamasız, filtresiz bir uç — bkz. krokiVectorService; hata sayfayı düşürmez).
        const [registered, standInfo, krokiDocs] = await Promise.all([
          alaniId != null ? listSalonlar(alaniId) : Promise.resolve([]),
          getSalonlarByFuar(selectedFuarId).catch(() => ({ salonlar: [] })),
          alaniId != null ? getHallFloorPlanDocuments(alaniId) : Promise.resolve({ ok: false }),
        ]);
        if (ignore) return;
        const standBySalonId = new Map(
          (standInfo?.salonlar ?? []).map((s) => [Number(s.salonId), s.standCount])
        );

        const merged = registered.map((s) => {
          const linked = linkedBySalonId.get(Number(s.salonId));
          return {
            salonId: s.salonId,
            salonName: s.salonName,
            active: linked != null,
            salonToFuarId: linked?.salonToFuarId ?? null,
            standCount: standBySalonId.get(Number(s.salonId)) ?? 0,
            // #164: true / false, ya da null = fdsvector'e sorulamadı.
            hasKroki: krokiDocs.ok ? krokiDocs.byHallId.has(String(s.salonId)) : null,
            // #204: Salon Planı fuar alanındaki salondan (her kayıtlı salonda var), Alan Planı
            // yalnızca bu fuara bağlı salonda.
            salonPlaniDurum: s.salonPlaniDurum ?? CIZIM_DURUM.CIZIM_YOK,
            salonPlaniDurumTarihi: s.salonPlaniDurumTarihi ?? null,
            // #234: backend bunu zaten veriyordu (FuarService.toHallRow), sayfa okumuyordu.
            altyapiPlaniDurum: s.altyapiPlaniDurum ?? CIZIM_DURUM.CIZIM_YOK,
            altyapiPlaniDurumTarihi: s.altyapiPlaniDurumTarihi ?? null,
            alanPlaniDurum: linked ? (linked.alanPlaniDurum ?? CIZIM_DURUM.CIZIM_YOK) : null,
            alanPlaniDurumTarihi: linked?.alanPlaniDurumTarihi ?? null,
            // #236: null = Alan Planı başlatılabilir; yoksa nedeni (backend #235 ile aynı kural).
            alanPlaniEngeli: linked ? alanPlaniEngeli(linked) : null,
            // #655 / #658: the h-max counts of backend #654 (null = an older backend, nothing is claimed).
            hmaxStandCount: linked?.standCount ?? null,
            toDrawCount: linked?.toDrawCount ?? null,
          };
        });
        merged.sort((a, b) => {
          const an = Number(a.salonName), bn = Number(b.salonName);
          if (!Number.isNaN(an) && !Number.isNaN(bn)) return an - bn;
          return String(a.salonName).localeCompare(String(b.salonName), "tr");
        });
        setRows(merged);
      } catch (e) {
        if (!ignore) setError(e.message);
      } finally {
        if (!ignore) setLoading(false);
      }
    }

    run();
    return () => { ignore = true; };
  }, [selectedFuarId, reloadToken]);

  async function runAction(fn, okMsg) {
    setActionLoading(true);
    setError(null);
    try {
      await fn();
      refresh();
      setSuccessMsg(okMsg);
    } catch (e) {
      setError(e.message);
    } finally {
      setActionLoading(false);
    }
  }

  const handleActivate = (row) =>
    runAction(
      () => addSalonToFuar(selectedFuarId, row.salonId),
      tx("salonlar.buFuaraBaglandi", { v: row.salonName ?? "Salon" })
    );

  const handleDeactivate = (row) =>
    runAction(
      () => removeSalonFromFuar(selectedFuarId, row.salonId),
      tx("salonlar.buFuardanCikarildi", { v: row.salonName ?? "Salon" })
    );

  const handleActivateAll = () =>
    runAction(
      () => activateAllFairgroundSalons(selectedFuarId),
      tx("salonlar.kayitliTumSalonlarBuFuara")
    );

  // #204: Alan Planı durumu hemen yazılır; dönen salon satırıyla yalnızca o satır güncellenir.
  async function handleAlanPlaniDurumu(row, durum) {
    setAlanBusy(row.salonId);
    setError(null);
    try {
      const out = await setAlanPlaniDurumu(selectedFuarId, row.salonId, durum);
      const h = out?.data;
      setRows((prev) => prev.map((r) => (r.salonId === row.salonId ? {
        ...r,
        alanPlaniDurum: h?.alanPlaniDurum ?? durum,
        alanPlaniDurumTarihi: h?.alanPlaniDurumTarihi ?? r.alanPlaniDurumTarihi,
        alanPlaniEngeli: h ? alanPlaniEngeli(h) : r.alanPlaniEngeli,
      } : r)));
      setSuccessMsg(out?.message || tx("salonlar.alanPlaniDurumuKaydedildi", { v: row.salonName ?? tx("salonlar.salon") }));
    } catch (e) {
      setError(e.message);
    } finally {
      setAlanBusy(null);
    }
  }

  const inactiveCount = rows.filter((r) => !r.active).length;

  // #204 / #234: salon düzeyindeki planın rozeti, BİLGİ AMAÇLI. Çizim yoksa rozet planı o katmanda
  // tam düzenlemede açar (#193; #228: katman adreste) — yalnızca o rotaya girebilen gruplar için.
  const salonDuzeyiPlan = (r, plan, katman) => {
    const pill = (
      <CizimDurumuPill
        id={`salonlar-${plan}-${r.salonId}`} plan={plan}
        durum={r[`${plan}Durum`]} tarih={r[`${plan}DurumTarihi`]}
      />
    );
    if (r[`${plan}Durum`] !== CIZIM_DURUM.CIZIM_YOK || !salonPlaniAcabilir || fuarAlaniId == null) return pill;
    return (
      <Link
        to={`/Management/FairAreas/${fuarAlaniId}/Salonlar/${r.salonId}/Plan?katman=${katman}`}
        title={tx("salonlar.cizimYokBuPlaniDuzenlemek")}
        className="text-decoration-none"
      >
        {pill}
      </Link>
    );
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={tx("salonlar.salonlar")} pageTitle={tx("salonlar.salonlarVeKrokiler")} />

        {error && <Alert color="danger">{error}</Alert>}
        {successMsg && <Alert color="success">{successMsg}</Alert>}

        {!selectedFuarId && <Alert color="warning">{tx("salonlar.onceUsttenBirFuarSecin")}</Alert>}

        {selectedFuarId && (
          <Card>
            <CardHeader className="d-flex align-items-center gap-2 flex-wrap">
              <h6 className="card-title mb-0 flex-grow-1">
                {fuarAlaniName ?? tx("salonlar.fuarAlani")}{" "}{tx("salonlar.salonlar2")}{" "}<Badge color="light" className="text-dark ms-1">{rows.length}</Badge>
              </h6>
              <Link to="/Management/Fairs/Rules?tab=hmax" className="btn btn-soft-primary btn-sm">
                <i className="bx bx-ruler me-1" />{tx("salonlar.yukseklikLimitleri")}
              </Link>
              {inactiveCount > 0 && (
                <Button size="sm" color="primary" disabled={actionLoading} onClick={handleActivateAll}>
                  {tx("salonlar.tumunuAktifEt", { inactiveCount })}
                </Button>
              )}
            </CardHeader>
            <CardBody className="p-0">
              {loading ? (
                <div className="text-center py-5"><Spinner color="primary" /></div>
              ) : rows.length === 0 ? (
                <div className="text-muted text-center py-4">
                  {tx("salonlar.buFuarAlanindaKayitliSalon")}
                  {fuarAlaniId != null && (
                    <Link to={`/Management/FairAreas/${fuarAlaniId}/Salonlar`}>{tx("salonlar.fuarAlanlariSalonlar")}</Link>
                  )}{" "}
                  {tx("salonlar.uzerindenSalonEkleyin")}
                </div>
              ) : (
                <div className="table-responsive">
                  <Table className="align-middle table-nowrap mb-0">
                    <thead className="table-light">
                      <tr>
                        <th className="ps-3">{tx("salonlar.salon")}</th>
                        <th>{tx("salonlar.durum")}</th>
                        {/* WAS (#164): <th title="fdsvector'de bu salonun Salon Planı dokümanı var mı ...">Kroki</th> */}
                        <th title={tx("salonlar.fuarAlanindakiSalonunSalonPlani")}>{tx("salonlar.salonPlani")}</th>
                        <th title={tx("salonlar.fuarAlanindakiSalonunAltyapiPlani")}>{tx("salonlar.altyapiPlani")}</th>
                        <th title={tx("salonlar.buFuarinStandYerlesimiCizim")}>{tx("salonlar.alanPlaniKroki")}</th>
                        <th>{tx("salonlar.stand")}</th>
                        <th className="pe-3">{tx("salonlar.aksiyon")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((r) => (
                        <tr key={r.salonId}>
                          <td className="ps-3 fw-semibold">
                            <Link to={`/Management/Salonlar/${r.salonId}`} title={tx("salonlar.salonKarti")}>
                              {r.salonName ?? tx("salonlar.salon2", { salonId: r.salonId })}
                            </Link>
                          </td>
                          <td>
                            <Badge color={r.active ? "success" : "secondary"}>
                              {r.active ? tx("salonlar.aktif") : tx("salonlar.pasif")}
                            </Badge>
                          </td>
                          {/* WAS (#164): Var / Yok / ? rozeti — fdsvector'de Salon Planı dokümanı var mı.
                              #204: yerine Salon Planı çizim durumu; doküman bilgisi alttaki ipucu. */}
                          <td>
                            {/* WAS (#204): Çizim yoksa <Link to=".../Plan"> (katmansız) içinde, değilse düz
                                <CizimDurumuPill plan="salonPlani" … /> — #234/#228'de salonDuzeyiPlan'a
                                taşındı; kısayol artık ?katman= ile açıyor. */}
                            {salonDuzeyiPlan(r, "salonPlani", KROKI_LAYERS.FLOORPLAN)}
                            {r.hasKroki && r.salonPlaniDurum === CIZIM_DURUM.CIZIM_YOK && (
                              <div className="text-muted" style={{ fontSize: 11 }} title={tx("salonlar.fdsvectorDeBuSalonunSalon")}>
                                {tx("salonlar.dokumanVar")}
                              </div>
                            )}
                          </td>
                          <td>{salonDuzeyiPlan(r, "altyapiPlani", KROKI_LAYERS.INFRASTRUCTURE)}</td>
                          <td>
                            {r.active ? (
                              <>
                                <CizimDurumuPill
                                  id={`salonlar-alan-plani-${r.salonId}`} plan="alanPlani"
                                  durum={r.alanPlaniDurum} tarih={r.alanPlaniDurumTarihi}
                                  busy={alanBusy === r.salonId}
                                  disabled={!personel || alanBusy != null}
                                  menuHeader={tx("salonlar.cizimDurumunuDegistir")}
                                  onChange={(durum) => handleAlanPlaniDurumu(r, durum)}
                                  lockedDurums={r.alanPlaniEngeli ? ALAN_PLANI_KILITLI_DURUMLAR : null}
                                  lockedReason={r.alanPlaniEngeli}
                                  extraItems={(
                                    // WAS (until #653): disabled={Boolean(r.alanPlaniEngeli)} - the page it opens shows the reason itself.
                                    <DropdownItem
                                      onClick={() => navigate(`/Management/Salonlar/${r.salonId}/AlanPlani`)}
                                    >
                                      <MapIcon size={13} className="me-2" />{tx("salonlar.alanPlaninaGit")}
                                    </DropdownItem>
                                  )}
                                />
                                {r.alanPlaniEngeli && (
                                  <div className="text-muted" style={{ fontSize: 11 }} title={r.alanPlaniEngeli}>
                                    {ALAN_PLANI_ENGEL_KISA}
                                  </div>
                                )}
                                {/* #655: "N çizilecek" under the pill (only while N > 0); #658: the amber marker of a completed plan with new stands */}
                                <CizilecekRozeti hall={{ salonPlaniDurum: r.salonPlaniDurum, standCount: r.hmaxStandCount, toDrawCount: r.toDrawCount }} tamamGoster={false} className="mt-1" />
                                <YenidenCizilecekIsareti hall={{ alanPlaniDurum: r.alanPlaniDurum, toDrawCount: r.toDrawCount }} className="mt-1" />
                              </>
                            ) : (
                              <span className="text-muted" title={tx("salonlar.salonBuFuardaAktifDegil")}>—</span>
                            )}
                          </td>
                          <td>{r.standCount > 0 ? <Badge color="info">{r.standCount}</Badge> : <span className="text-muted">0</span>}</td>
                          <td className="pe-3 d-flex gap-1 align-items-center">
                            {r.active && (
                              <Link
                                to={`/Management/Salonlar/${r.salonId}/DurumHaritasi`}
                                className="btn btn-sm btn-soft-primary" title={tx("salonlar.durumHaritasiStandlariIzinBorc")}
                              >
                                <Palette size={14} />
                              </Link>
                            )}
                            {r.active ? (
                              <Button size="sm" color="danger" outline disabled={actionLoading} onClick={() => handleDeactivate(r)}>
                                {tx("salonlar.pasifYap")}
                              </Button>
                            ) : (
                              <Button size="sm" color="primary" outline disabled={actionLoading} onClick={() => handleActivate(r)}>
                                {tx("salonlar.aktifEt")}
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              )}
            </CardBody>
          </Card>
        )}
      </Container>
    </div>
  );
}
